/** /everything is always Spanish — not tied to site locale. */
export const ev = {
  title: "⭐ guidoti's super-mega-ultra-fastest file transfer for friends",
  items: "ítem",
  itemsPlural: "ítems",
  noteTitle: "notita?",
  noteTitlePlaceholder: "titulo",
  noteTextPlaceholder: "escribile algo a guidoti",
  saveNote: "guardar",
  savingNote: "Guardando…",
  searchTitle: "buscar?",
  searchPlaceholder: "buscar archivo…",
  searchClear: "Limpiar búsqueda",
  uploading: "Subiendo",
  loadingManifest: "Cargando manifest…",
  retry: "Reintentar",
  backHome: "Volver al inicio",
  overLimit: '"{name}" pesa {size} — supera el límite de 5 GB por archivo.',
  uploadSuccess: '¡"{name}" subido!',
  uploadFailed: 'Error al subir "{name}": {error}',
  downloadOpened: '"{name}" abierto — usá Guardar como en la pestaña nueva.',
  downloadSuccess: '"{name}" descargado.',
  downloadFailed: "Error al descargar: {error}",
  download: "Descargar",
  noteEmpty: "Escribí algo antes de guardar.",
  noteSaved: '¡"{name}" guardado!',
  noteFailed: "Error al guardar la nota: {error}",
  reorderFailed: "Error al guardar el orden: {error}",
  deleteSuccess: '"{name}" eliminado.',
  deleteFailed: "Error al eliminar: {error}",
  dropToUpload: "Soltá en cualquier lado para subir",
  maxFileSize: "Máx. 5 GB por archivo",
  storageLabel: "{used} / {limit} · {pct}%",
  quotaExceeded: '"{name}" no entra — quedan {remaining} en el bucket. Liberá espacio antes.',
  themeSwitchToDark: "Modo oscuro",
  themeSwitchToLight: "Modo claro",
  storageTooltip:
    "Backblaze B2: {used} de {limit} usados ({remaining} libres). Free tier — sin cargos hasta el límite.",
  copy: "Copiar",
  copied: "¡Copiado!",
  copyFailed: "No se pudo copiar al portapapeles.",
  share: "Compartir",
  linkCopied: "¡Link copiado!",
  shareFailed: "No se pudo copiar el link.",
  fileNotFound: "Archivo no encontrado — puede que se haya borrado.",
  previewUnavailable: "No hay preview para este tipo de archivo.",
  previewUseDownload: "Usá Descargar arriba.",
  previewLoadFailed: "Error al cargar:",
  close: "Cerrar",
  authPlaceholder: "magic",
  authSuccess: "Borrado habilitado — solo por esta sesión.",
  authFailed: "Password incorrecta.",
  authNotConfigured: "Borrado no configurado en el servidor.",
  authActive: "borrar ✓",
};

export function evMsg(template, vars = {}) {
  return Object.entries(vars).reduce(
    (str, [key, value]) => str.replaceAll(`{${key}}`, String(value)),
    template
  );
}
